var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"pricing-page"}},[(_vm.customerSessionSecret)?_c('stripe-pricing-table',{attrs:{"pricing-table-id":_vm.pricingTableId,"publishable-key":_vm.publishableKey,"customer-session-client-secret":_vm.customerSessionSecret}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }